export default function brand_details()
{
    return({
        //Company Information
        name: "Empire Partner Foundation",
        subtitle: "Department of Water and Sanitation",
        sub_entity_name: "REimagine",

        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-logo")
        .replace(/['"]+/g, "")
    });
}
